import { AutocompleteDTO, EnglishArabicDTO } from "bbsf-controls"
import { ParticipantModel } from './ParticipantModel';
export class ImpersonationRuleModel
{
      ID?:number
      SourceUser:any
      DestinationUser:any
      UserAutoCompleteDTO:any
      ExpiresAt?:Date
      IsActive:boolean
      SourceParticipantDTO:ParticipantModel=new ParticipantModel;
      DestinationParticipantDTO:ParticipantModel=new ParticipantModel;

}